/**
 * A pilha do gráfico «Composição do armazenamento»: uma faixa por lugar onde o
 * byte está, de baixo para cima, com a cor que a legenda usa.
 *
 * Cada chave é uma série que a API entrega pronta e disjunta das outras — a
 * tela empilha, não soma nem subtrai. É também a lista de séries que a tela
 * pede (`INSIGHTS_METRICS` em `api.ts` sai daqui): antes eram duas listas, e as
 * faixas de separações e de documentos ficaram desenhadas sem nunca receber
 * dado, porque só uma delas foi atualizada.
 *
 * F-GC.6: "Máscaras no disco" virou três faixas — a base da pirâmide, os níveis
 * derivados e o resto (manifestos, preparação), este calculado no servidor —; as
 * miniaturas duráveis saíram dos originais (o original expira e a miniatura
 * fica); e a caixa de entrada do SFTP ganhou faixa própria.
 *
 * Sem imports de propósito: roda no `node --test` fora do bundler.
 */

export interface StorageBand {
  key: string;
  label: string;
  color: string;
}

export const STORAGE_STACK = [
  { key: "originals_bytes_total", label: "Arquivos originais", color: "#34d399" },
  { key: "thumbs_bytes_total", label: "Miniaturas", color: "#a7f3d0" },
  { key: "pyramid_base_bytes_total", label: "Pirâmide base", color: "#f59e0b" },
  { key: "pyramid_levels_bytes_total", label: "Pirâmide níveis", color: "#fcd34d" },
  { key: "masks_other_bytes_total", label: "Preparação e manifestos", color: "#fef3c7" },
  { key: "ready_images_bytes_total", label: "Imagens prontas", color: "#22d3ee" },
  { key: "separations_bytes_total", label: "Separações do Esko", color: "#f472b6" },
  { key: "documents_local_bytes_total", label: "Documentos no cache quente", color: "#fb923c" },
  { key: "cold_bytes_total", label: "Na nuvem (frio)", color: "#60a5fa" },
  { key: "database_bytes_total", label: "Banco de dados", color: "#a78bfa" },
  { key: "watch_bytes_total", label: "Caixa de entrada /watch", color: "#e879f9" },
  // Sem card, de propósito: cópia de trabalho de render, índice do motor e
  // recortes de ferramenta. Perto de zero no dia a dia — crescer é sintoma.
  { key: "other_bytes_total", label: "Outros", color: "#64748b" },
] as const satisfies ReadonlyArray<StorageBand>;

export type StorageStackKey = (typeof STORAGE_STACK)[number]["key"];

/** As séries que a pilha precisa, na ordem dela. */
export const STORAGE_STACK_METRICS: readonly StorageStackKey[] = STORAGE_STACK.map(
  (band) => band.key,
);
